import Grid from "@mui/material/Grid";
import React from "react";
import PropTypes from "prop-types";
import EditableSeverityChip from "components/SeverityChip/EditableSeverityChip";
import { DatePicker } from "components/DatePicker";
import { TextField } from "components/TextField";
import { FormSectionTitle } from "components/AlertsManagement/Case/form/FormSectionTitle";

export const DiagnosticDetailsForm = ({ formik }) => {
  return (
    // We need the outer wrapper to be a Grid container,
    // so that everything internal is relative to it and not anything outside the component
    <Grid container direction="column" gap={2}>
      <Grid container item direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12}>
          <FormSectionTitle variant="h5">
            Diagnostic report details
          </FormSectionTitle>
        </Grid>
        <Grid item xs={12}>
          <FormSectionTitle required={true}>Diagnostic</FormSectionTitle>
        </Grid>
        <Grid container item direction="row" alignItems="center" gap={2}>
          <Grid item xs={12} sm="auto">
            <EditableSeverityChip
              id="diagnostic.case_severity_type"
              name="diagnostic.case_severity_type"
              severity={formik.values.diagnostic.case_severity_type}
              setSeverity={id =>
                formik.setFieldValue("diagnostic.case_severity_type", id)
              }
            />
          </Grid>
          <Grid item xs={12} sm="auto">
            <DatePicker
              id="diagnostic.date_time"
              name="diagnostic.date_time"
              label="Diagnosis Date"
              ariaLabel="diagnostic report date"
              date={formik.values.diagnostic.date_time}
              onChange={date =>
                formik.setFieldValue("diagnostic.date_time", date)
              }
              required
              disableFuture
              slotProps={{
                textField: {
                  id: "diagnostic.date_time",
                  onBlur: formik.handleBlur,
                  error:
                    formik.touched.diagnostic?.date_time &&
                    Boolean(formik.errors.diagnostic?.date_time),
                  helperText:
                    formik.touched.diagnostic?.date_time &&
                    formik.errors.diagnostic?.date_time
                }
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container item direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12}>
          <FormSectionTitle>Summary</FormSectionTitle>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="diagnostic.description"
            name="diagnostic.description"
            label="Description"
            fullWidth
            required
            value={formik.values.diagnostic.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.diagnostic?.description &&
              Boolean(formik.errors.diagnostic?.description)
            }
            helperText={
              formik.touched.diagnostic?.description &&
              formik.errors.diagnostic?.description
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="diagnostic.recommendation"
            name="diagnostic.recommendation"
            label="Recommendation"
            fullWidth
            value={formik.values.diagnostic.recommendation}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.diagnostic?.recommendation &&
              Boolean(formik.errors.diagnostic?.recommendation)
            }
            helperText={
              formik.touched.diagnostic?.recommendation &&
              formik.errors.diagnostic?.recommendation
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

DiagnosticDetailsForm.propTypes = {
  formik: PropTypes.object
};
